import { css } from '@emotion/core';
import { typography } from '../../../../styles/typography';
import { colorsPalette } from '../../../../styles/colors';
import { MediaQueries } from '../../../../styles/Grid';

export const selectContainer = css({
  position: 'relative',
  display: 'inline-block',
  marginRight: 9.5,
});

export const phoneNumberContainer = css({
  alignItems: 'center',
  background: colorsPalette.white,
  border: `1px solid ${colorsPalette.grey20}`,
  borderRadius: 4,
  display: 'flex',
  flexWrap: 'wrap',
  padding: '6px 16px',

  height: '56px',
  // background: 'yellow',

  '&[data-shrink="true"]': {
    padding: '24px 16px 8px',
    height: '56px',
  },

  '&[data-focus="true"]': {
    border: `1px solid ${colorsPalette.teal}`,
  },

  '&[data-error="true"]': {
    border: `1px solid ${colorsPalette.red120}`,
  },
});
export const phoneNumberHolder = css({
  position: 'relative',
  height: 24,
  width: '100%',
  display: 'flex',
});

export const flagArrowContainer = css({
  zIndex: 2,
  position: 'relative',
  background: colorsPalette.white,
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',

  i: {
    position: 'relative',
  },
});

export const inputCss = css(typography.effra18, {
  flex: 1,
  border: 'none',
  fontSize: '16px !important',
  background: colorsPalette.transparent,
  outline: 'none',
  padding: 0,
  margin: 0,
  lineHeight: 'unset',
  top: 0,
  width: '100%',
  position: 'absolute',
  height: '100%',
  color: colorsPalette.black + ' !important',
  height: 'auto',
  padding: '0.5px 0',
  lineHeight: 0,

  [MediaQueries.sm]: {
    minWidth: 80,
  },

  // hide input number spin
  '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button ': {
    WebkitAppearance: 'none',
    margin: 0,
  },
  MozAppearance: 'textfield',
});

export const iconCss = css({
  position: 'static',
  marginLeft: 6,
  fontSize: 7,
  fontWeight: 'bold',
});

export const labelCss = css(typography.effra18, {
  bottom: 0,
  color: colorsPalette.tint,
  fontSize: '16px !important',
  overflow: 'visible',
  pointerEvents: 'none',
  position: 'relative',
  whiteSpace: 'nowrap',
  lineHeight: '24px',
  '&[data-shrink="true"]': {
    display: 'none',
  },

  div: {
    span: { color: colorsPalette.red },
  },
});

export const numberPlaceholder = css(typography.effra16, {
  marginRight: 8,
  padding: '2.5px 0',
  // background: 'red',
  lineHeight: '16px',
});

export const imageContainer = css({
  width: 24,
  height: 24,
  display: 'inline-block',
  position: 'relative',
  overflow: 'hidden',
  borderRadius: '50%',
});

export const shrinkPlaceholder = css(typography.effra12, {
  position: 'absolute',
  top: -18,
  width: '100%',
  color: colorsPalette.teal,
  div: {
    span: { color: colorsPalette.red },
  },
  fontSize: '12px',
  '&[data-shrink="false"]': {
    display: 'none',
  },
  '&[data-shrink="true"]': {
    color: colorsPalette.tintgrey,
  },

  '&[data-focus="true"]': {
    color: colorsPalette.teal,
  },

  '&[data-error="true"]': {
    color: colorsPalette.red120,
  },
});

export const imageCss = css({
  borderRadius: 2,
  //delete below properties after integration
  width: '100%',
  height: 'auto',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  objectFit: 'none',
});

export const inputDisabled = css({
  opacity: 0.8,
});

export const inputLabelHolder = css({
  position: 'relative',
  zoom: 1,
  width: '100%',
  flex: '1',
});

export const selectArrowIconCss = css({
  right: 0,
});
